import React from 'react';
import PlayListArtistContainer from 'containers/PlayListArtistContainer';

export default function PlayListArtistPage() {
  return <PlayListArtistContainer />;
}
